// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconTransfer = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M5.375 11H13V9H5.375L8 6H5.5L2 10l3.5 4H8zm13.25 2H11v2h7.625L16 18h2.5l3.5-4-3.5-4H16z" />
  );
export default SvgIconTransfer;
